module.exports = __webpack_public_path__ + "static/img/4279_phase_function_Paper_PointsHejduk_Prediction.6226e60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4279_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BQSK
// module chunks = 0